import { ConstToEnumType } from '@whitelist/wl-old-library/utils/types'
import { nanoid } from 'nanoid'

export const AlertTypes = {
  info: 'info',
  warning: 'warning',
  error: 'error',
  success: 'success'
} as const

export const ActionPositions = {
  top: 'top',
  bottom: 'bottom'
} as const

export interface RawAlertInterface {
title: string,
type: ConstToEnumType<typeof AlertTypes>,
autoDelete: boolean,
deletable?: boolean,
onlyContent?: boolean,
content?: string,
wordBreak?: boolean,
fillWidth?: boolean,
action?: {
  text: string,
  callback: void,
  position?: ConstToEnumType<typeof ActionPositions>
},
messages: string[],
onClose?: () => unknown,
contentType?: 'text' | 'html'
}

export interface AlertInterface extends RawAlertInterface {
  id: ReturnType<typeof nanoid>
}
